import SpriteSymbol from "../../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/_svg-sprite-loader@6.0.9@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "open",
  "use": "open-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"open\"><g fill-rule=\"nonzero\" stroke-width=\"0\"><rect width=\"16\" height=\"16\" rx=\"2\" /><path d=\"M4 8h8M8 4v8\" stroke=\"#FFF\" stroke-width=\"2\" stroke-linecap=\"square\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id